import { render, staticRenderFns } from "./CardTotalInvoice.vue?vue&type=template&id=37d6df10"
import script from "./CardTotalInvoice.vue?vue&type=script&lang=js"
export * from "./CardTotalInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports